import { App } from 'antd';

import type { IApiError } from '@/api/types';

import { generateErrorMessage } from '../helpers';

import { useLoader } from './useLoader';

interface IParams<P> {
  successMessage?: string;
  apiRequestCallback: () => { unwrap: () => Promise<P> };
  successCallback?: (response: P) => void;
  errorCallback?: VoidFunction;
}

export const useApiRequest = () => {
  const { showLoader, hideLoader } = useLoader();
  const { message } = App.useApp();

  return async <P>({ successMessage, apiRequestCallback, successCallback, errorCallback }: IParams<P>) => {
    try {
      showLoader();

      const response = await apiRequestCallback().unwrap();

      if (successMessage) {
        message.success(successMessage);
      }

      successCallback?.(response);
    } catch (error) {
      message.error(generateErrorMessage(error as IApiError));
      errorCallback?.();
    } finally {
      hideLoader();
    }
  };
};
